import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=9788ce7a&"
import script from "./VideoModule.vue?vue&type=script&lang=js&"
export * from "./VideoModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports